<div class="a-radio-group">
  <div class="radio" *ngFor="let item of items; let i = index;">
    <input
      id="radio-{{ name + i }}"
      [value]="item.value" 
      [class.is-invalid]="control.invalid && isSubmitted"
      (change)="onChange($event)"
      [checked]="item.value === control.value" 
      (click)="onRadioClick(item.value)"
      name="radio-{{ name + i }}" 
      type="radio">
    <label for="radio-{{ name + i }}" class="radio-label">{{ item.label }}</label>
  </div>
</div>